import React, { type FC } from 'react'

import styled from '@emotion/styled'

interface IconIndentSolidProps {
  width?: string
  height?: string
  flipH?: boolean
}

const StyledSVG = styled(({ $flipH, children, ...props }) =>
  React.createElement('svg', props, children),
)`
  ${({ $flipH }: { $flipH: boolean }) => ($flipH === true ? 'transform: scaleX(-1);' : '')}
`

const IconIndentSolid: FC<IconIndentSolidProps> = ({
  width,
  height,
  flipH,
}) => {
  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 448 512"
      $flipH={flipH}
    >
      <path
        d="M0 64C0 46.3 14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64zM192 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM127.8 268.6L25.8 347.9C15.3 356.1 0 348.6 0 335.3V176.7c0-13.3 15.3-20.8 25.8-12.6l101.9 79.3c8.2 6.4 8.2 18.9 0 25.3z"
        fill="currentColor"
        shapeRendering="geometricPrecision"
      />
    </StyledSVG>
  )
}

export default IconIndentSolid
